// ----------------------------------------------------------------------
// <copyright file="Izenda.PerformanceStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Izenda Performace View Model
 */
!(function () {
  var m = require('mobx');
  var action = require('mobx').action;
  var fetcher = require('fetchers/Izenda.AdvancedSettingDataFetcher');
  var PerformanceModel = require('./models/Izenda.Performance');
  var uiState = require('logic/Izenda.UiState');
  var AppGlobal = require('Izenda.AppGlobal');

  function PerformanceStore() {
    this.performanceModel = new PerformanceModel();
  }

  /**
   * init for the first time componentWillMount, link between UISTate and store
   */
  PerformanceStore.prototype.init = action(function () {

    this.observeTenantId();
    uiState.setCheckDirtyFunction(function() {
      return this.performanceModel.isDirty;
    }.bind(this));

    return this.getInitial();
  });

  /**
   * Observe tenantID on setting level
   */
  PerformanceStore.prototype.observeTenantId = action(function () {
    this.disposePerformance = m.observe(uiState, 'tenantId', function () {
      this.getInitial();
    }.bind(this));
  });

  /**
   * unlink between UIState and store
   */
  PerformanceStore.prototype.destroy = action(function () {
    this.disposePerformance();
    uiState.resetCheckDirtyFunction();
  });

  /**
   * Load Initial Data
   */
  PerformanceStore.prototype.getInitial = action(function () {
    this.performanceModel.resetErrorMessage();
    return this.updateData();
  });

  /**
   * [description]
   * @param  {[type]} ) [description]
   * @return {[type]}   [description]
   */
  PerformanceStore.prototype.updateData = action(function () {
    return fetcher.loadPerformance(uiState.getTenantId())
                  .then(this.performanceModel.readPerformanceData.bind(this.performanceModel));
  });

  /**
  * Save Performance
  */
  PerformanceStore.prototype.onSave = action(function () {
    var performanceModel = this.performanceModel;
    var saveData = performanceModel.buildSaveData(uiState.getTenantId());

    return fetcher.savePerformance(saveData)
                  .then(performanceModel.showAlertMessage.bind(performanceModel))
                  .then(performanceModel.resetDirty)
                  .then(this.updateData.bind(this))
                  .then(AppGlobal.setPerformance.bind(AppGlobal, saveData)); // update AppGlobal when have changes
  });

  /**
   * Load Performace
   */
  PerformanceStore.prototype.loadPerformance = action(function () {
    return fetcher.loadPerformance(uiState.getTenantId());
  });

  module.exports = PerformanceStore;
}());



// WEBPACK FOOTER //
// ./ui/logic/Izenda.PerformanceStore.js